import Reveal from 'components/ui/Reveal';
import SectionHeading from 'components/ui/SectionHeading';
import { WHY_BENEFITS } from 'lib/constants';
import { Heart, Zap, Leaf, Sun, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const iconMap = {
  Heart,
  Zap,
  Leaf,
  Sun,
  Sparkles
};

export default function WhyMoraPreview() {
  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-20">
        <Reveal>
          <SectionHeading
            eyebrow="WHY Mora"
            title="Why People Choose Mora"
            subtitle="Wholesome nourishment, natural crunch, and the authentic taste of Indian tradition"
            className="mb-8 sm:mb-12 md:mb-14"
          />
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3.5 sm:gap-5 md:gap-6 mb-10 sm:mb-14">
          {WHY_BENEFITS.slice(0, 5).map((benefit, index) => {
            const Icon = iconMap[benefit.icon] || Sparkles;

            return (
              <Reveal key={index} delay={index * 0.1}>
                <div className="group bg-Mora-ivory p-5 sm:p-6 md:p-7 rounded-2xl border border-Mora-beige/60 shadow-sm h-full flex flex-col items-center text-center hover:shadow-lg hover:border-Mora-caramel/30 hover:-translate-y-1 transition-all duration-300">
                  <div className="mb-4 sm:mb-5 w-14 h-14 bg-Mora-beige/50 rounded-xl flex items-center justify-center text-Mora-caramel group-hover:bg-Mora-caramel/20 transition-colors">
                    <Icon className="w-7 h-7 sm:w-8 sm:h-8" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-heading text-base sm:text-lg font-semibold text-Mora-dark mb-1.5 sm:mb-2">
                    {benefit.title}
                  </h3>
                  <p className="font-body text-xs sm:text-sm text-Mora-dark/70 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.4}>
          <div className="text-center">
            <Link
              to="/why-mora"
              className="inline-flex items-center gap-2 font-body font-semibold text-Mora-brown hover:text-Mora-caramel transition-colors border-b-2 border-transparent hover:border-Mora-caramel pb-1 text-base sm:text-lg"
            >
              Learn More
              <span aria-hidden="true">&rarr;</span>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
